import { HttpBackend, HttpClient, HttpEvent, HttpHeaders, HttpRequest, HttpResponse, ɵHttpInterceptingHandler } from '@angular/common/http';
import { EnvironmentInjector, inject, Injectable } from '@angular/core';
import { Observable, Observer, scan, map, switchMap } from 'rxjs';
import oboe from 'oboe';

import { AI_API_HEADERS } from '../di';


@Injectable({ providedIn: 'root' })
export class OboeBackend implements HttpBackend {
	headers$ = inject(AI_API_HEADERS)

	handle(request: HttpRequest<any>): Observable<HttpEvent<any>> {
		return this.createOboeObservable(request);
	}

	private createOboeObservable(request: HttpRequest<any>) {
		let headers: HttpHeaders;
		let status = 0;

		return this.headers$.pipe(
			switchMap(apiHeaders => new Observable((observer: Observer<HttpEvent<any>>) => {
				const oboeService = oboe({
					url: request.urlWithParams,
					method: request.method,
					body: request.body,
					cached: false,
					headers: apiHeaders,
				});

				oboeService
					.on('start', (rawStatus, rawHeaders) => {
						headers = rawHeaders;
						status = rawStatus;
					})
					.node('!.*', (data) => observer.next(data))
					.done(() => observer.complete());
			})),
			scan((list, data) => [...list, data], [] as HttpEvent<any>[]),
			map(body => new HttpResponse({
				url: request.url,
				body,
				headers,
				status
			})),
		);
	}
}

@Injectable({ providedIn: 'root' })
export class OboeHandler extends ɵHttpInterceptingHandler {
    constructor(backend: OboeBackend, injector: EnvironmentInjector) {
        super(backend, injector);
    }
}

@Injectable({ providedIn: 'root' })
export class OboeClient extends HttpClient {
    constructor(handler: OboeHandler) {
        super(handler);
    }
}